import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import global from '@/utils/global'
import i18n from '@/plugins/i18n'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueProgressBar from 'vue-progressbar'
import vue_progress_bar_options from "@/utils/vue_progress_bar_options"

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'toastify-js/src/toastify.css'

//last css import (override)
import "@/assets/css/global.scss"

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueProgressBar, vue_progress_bar_options)

Vue.config.productionTip = false
Vue.prototype.$utils = global

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
